/* eslint-disable no-unused-vars */

/**
 * enums for the fields tat go into a claim submission
 */
export enum AnswerFieldName {
  leaveScenario = 'leaveScenario',
  eventDate = 'eventDate',
  planType = 'planType',
  employeeType = 'employeeType',
  healthInsuranceProvider = 'healthInsuranceProvider',
  reason = 'reason',
  reasonQualifier1 = 'reasonQualifier1',
  reasonQualifier2 = 'reasonQualifier2',
  primaryFamilyMemberRelationship = 'primaryFamilyMemberRelationship',
  primaryFamilyMemberRelationshipQualifier1 = 'primaryFamilyMemberRelationshipQualifier1',
  primaryFamilyMemberRelationshipQualifier2 = 'primaryFamilyMemberRelationshipQualifier2',
  workRelated = 'workRelated',
  claimType = 'claimType',
  dateSymptomsFirstAppeared = 'dateSymptomsFirstAppeared',
  expectedReturnToWorkDate = 'expectedReturnToWorkDate',
  employerDateLastWorked = 'employerDateLastWorked',
  dismembermentOrLoss = 'dismembermentOrLoss',
  insuredSpouseWorking = 'insuredSpouseWorking',
  salaryCountNumDays = 'salaryCountNumDays',
  actualDeliveryMethod = 'actualDeliveryMethod',
  additionalComments = 'additionalComments',
}

/**
 * Paths for SOL_TotalLeave_Employee built external APIs
 */
export enum ApiPaths {
  activities = '/activities',
  autoSave = '/autosave',
  caches = '/caches',
  callbacksAvailable = '/callbacks-available',
  closeReminder = '/close-reminder',
  createReminder = '/create-reminder',
  ConvertFile = '/convert-uploaded-file',
  LeaveAvailibility = '/fc-leave-availibility',
  logout = '/logout',
  MergeUploadedFiles = '/merge-uploaded-files',
  MergeUploadedFilesBucketUrl = '/merge-uploaded-files-url',
  qualtrics = '/qualtrics',
  RefreshToken = '/refresh-token',
  remindersFunction = '/reminders-function',
  sessionInfo = `/session-info`,
  vbClaims = '/vb-claims',
  vbCoverage = '/vb-coverage',
  vbSubmission = '/vb-submission',
  absenceNotifications = '/customer/absence-notifications',
  absencePeriodDecisions = '/absence/absence-period-decisions',
  corpLeaveIncrements = '/customer/corporate-leave-increments',
  accommodationCases = '/customer/absence/accommodation-cases',
  ptoChoice = '/employer-classes/pto-choice',
  llPlanPath = '/plans-mapping',
}

/**
 * Paths for IRM_phenx-iac repo, `external-apis.yaml` file
 */
export enum ApiPathsEX {
  ada = '/ex/accommodation',
  callback = '/ex/callback',
  cases = '/ex/cases',
  document = '/ex/document',
  documents = '/ex/documents',
  draftClaim = '/ex/draftClaim',
  draftClaims = '/ex/draftClaims',
  employerPreferences = '/ex/employerpreferences',
  episodicAbsences = '/ex/episodicAbsences',
  esignature = '/ex/esignature',
  getPaymentPreferences = '/ex/getPaymentPreferences',
  getZelleEnrollmentsStatus = '/ex/getZelleEnrollmentsStatus',
  ldw = '/ex/ldw',
  person = '/ex/person',
  personData = '/ex/personData',
  preferences = '/ex/preferences',
  pregnancy = '/ex/pregnancy',
  refresh = '/ex/refresh',
  setPaymentPreferences = '/ex/setPaymentPreferences',
  submission = '/ex/submission',
  task = '/ex/task',
  webmessage = '/ex/webmessage',
  caseHistory = '/ex/case-history',
}

/**
 * Paths for IRM_phenx-iac repo, `external-analytics-apis.yaml` file
 */
export enum ApiPathsAN {
  error = '/an/error',
  leaveExtensions = '/an/leaveExtension',
  track = '/an/track',
}

/**
 * Paths for IRM_phenx-iac repo, `absence-apis.yaml` file
 */
export enum ApiPathsAB {
  tasks = '/ab/employee-tasks',
}

/**
 * Internal URL paths within the app
 */
export enum AppPaths {
  absenceHistory = '/app/absence-history/:ntn?',
  absenceHistoryAll = '/app/absence-history',
  appRoot = '/app',
  appLoginDirective = '/app?login=true',
  claimList = '/app/claim-list',
  claimsLeavePlan = '/app/leave-plan/:NTNId',
  claimStatus = '/app/claim-status',
  contactUs = '/app/contact-us',
  contactUsCallback = '/app/form/scheduled-callback',
  contactUsChat = '/app/contact-us/chat',
  contactUsMessages = '/app/contact-us/messages',
  dataLoadFailed = '/app/page/data-load-failed',
  documents = '/app/documents',
  error = '/app/error',
  feedback = '/app/page/feedback',
  file = '/app/file',
  filePersonalMedical = '/app/file/personal-medical',
  filePregnancy = '/app/file/pregnancy',
  form = '/app/form',
  duplicateClaim = '/app/duplicate',
  learninghub = '/app/learning-hub',
  externalRedirect = '/app/redirect',
  loading = '/app/loading',
  messages = '/app/messages',
  page = '/app/page/',
  payments = '/app/payments',
  time = '/app/time',
  profile = `/app/profile`,
  profileCommunicationPreferences = '/app/profile/communication-preferences',
  profileLanguagePreferences = '/app/profile/language-preferences',
  profilePaymentPreferences = '/app/profile/payment-preferences',
  root = '/',
  rootAlreadyRegistered = '/?a',
  startClaim = '/app/start',
  startClaimOld = '/app/page/start',
  supplemental = '/app/supplemental',
  taskDetails = '/app/task/:taskKey/details/:taskCodeName',
  userInitiatedTask = '/app/task/initiate/:taskCodeName',
  taskLlDescription = '/app/task/:taskKey/ll-description',
  tasks = '/app/tasks',
  newUpload = '/app/upload',
  extensionRequest = '/app/task/initiate/extension_request',
}

export const AppPathForms = {
  vbAccident: '/app/form/vb-accident',
  vbCriticalIllness: '/app/form/vb-critical-illness',
  vbHospital: '/app/form/vb-hospital',
} as const;

export enum AppStates {
  GET_KENTICO_DATA = 'GET_KENTICO_DATA',
  GET_KENTICO_DATA_ERROR = 'GET_KENTICO_DATA_ERROR',
  GET_SPLASH_CONFIG = 'GET_SPLASH_CONFIG',
  GET_SPLASH_CONFIG_ERROR = 'GET_SPLASH_CONFIG_ERROR',
  SHOW_SPLASH = 'SHOW_SPLASH',
  AUTHENTICATING = 'AUTHENTICATING',
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  AUTHENTICATED = 'AUTHENTICATED',
  NOT_REGISTERABLE = 'NOT_REGISTERABLE',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  FAILED_WITH_DATA = 'FAILED_WITH_DATA',
}

export enum TaskStatuses {
  upcoming = 1,
  pending_notification = 2,
  pending = 3,
  returned = 4,
  under_review = 5,
  escalated = 6,
  completed = 7,
  deleted = 8,
  ignored = 9,
  archived = 10,
}

export enum TaskUIStatuses {
  upcoming = 'UPCOMING',
  awaiting_action = 'Action required',
  in_review = 'RECEIVED',
  needs_action = 'RETURNED',
  ignored = 'IGNORED',
  completed = 'COMPLETED',
  archived = 'ARCHIVED',
}

export enum ButtonTypes {
  breadcrumb = 'breadcrumb',
  primary = 'primary',
  secondary = 'secondary',
  secondaryRed = 'secondaryRed',
  flat = 'flat',
  link = 'link',
  outline = 'outline',
  primaryLarge = 'primaryLarge',
  smallOutline = 'smallOutline',
}

/**
 * Keys for accessing objects in the cache
 */
export enum CacheKeys {
  activelogin = 'activelogin',
  assetReferences = 'asset_references',
  auth_state = 'auth_state',
  cache_registry = 'cache_registry',
  callCenterClosures = 'callCenterClosures',
  cognitoid = 'cognitoid',
  content_blob = 'content_blob',
  dimissedCalendarGuide = 'dismissed_calendar_guide',
  dismissedOutageWarnings = 'dismissed_outage_warnings',
  dynamicContent = 'dynamic_content',
  employer_content = 'employer_content',
  entryPoint = 'entryPoint',
  featureFlags = 'feature_flags',
  form_config = 'form_config',
  full_refresh_bypass = 'full_refresh_bypass',
  intakes_list = 'intakes_list',
  lastLoginTime = 'lastLoginTime',
  live_chat_form = 'live_chat_form',
  localized_string = 'localized_string',
  login_refresh_bypass = 'login_refresh_bypass',
  reference_remote_config = 'reference_remote_config',
  remote_config = 'remote_config',
  sessionCredentials = 'sessionCredentials',
  splash = 'splash',
  splash_config_current = 'splash_config_current',
  splash_config_upcoming = 'splash_config_upcoming',
  splash_config_recurring = 'splash_config_recurring',
  ssoCookieKey = 'ssoCookieKey',
  ssoCookieValue = 'ssoCookieValue',
  tasksConfig = 'tasks-config',
  tasksMap = 'task',
  taskStatusConfig = 'task-status-help',
  claimStatusConfig = 'status-help-icon',
  userInfo = 'userInfo',
}

export type CacheKeyType = `${CacheKeys}`;

export enum CaseStatus {
  closed = 'Closed',
  open = 'Open',
}

export enum CaseSubstatusCodenames {
  received_1_1 = 'received_sub_status_text',
  received_1_2 = 'sub_status_text___received_1_2',
  received_1_3 = 'sub_status_text___received_1_3',
  received_1_4 = 'sub_status_text___received_1_4',
  reviewing_2_1 = 'reviewing1_sub_status_text',
  reviewing_2_2 = 'reviewing2_sub_status_text',
  reviewing_2_3 = 'reviewing3_sub_status_text',
  reviewing_2_4 = 'sub_status_text___reviewing_2_4',
  reviewing_2_5 = 'sub_status_text___reviewing_2_5',
  reviewing_2_6 = 'sub_status_text___reviewing_2_6',
  reviewing_2_7 = 'sub_status_text___reviewing_2_7',
  reviewing_2_8 = 'sub_status_text___reviewing_2_8',
  reviewing_2_9 = 'sub_status_text___reviewing_2_9',
  reviewing_2_10 = 'sub_status_text___reviewing_2_10',
  reviewing_2_11 = 'sub_status_text___reviewing_2_11',
  management_3_1 = 'management1_sub_status_text',
  management_3_2 = 'management2_sub_status_text',
  management_3_3 = 'management3_sub_status_text',
  management_3_4 = 'sub_status_text___management_3_4', // unused
  management_3_5 = 'sub_status_text___management_3_5', // unused
  management_3_6 = 'sub_status_text___management_3_6',
  management_3_7 = 'sub_status_text___management_3_7',
  management_3_8 = 'sub_status_text___management_3_8',
  management_3_9 = 'sub_status_text___management_3_9',
  management_3_10 = 'sub_status_text___management_3_10',
  management_3_12 = 'sub_status_text___management_3_12',
  management_3_13 = 'sub_status_text___management_3_13',
  management_3_14 = 'sub_status_text___management_3_14',
  closed_4_1 = 'closed_sub_status_text',
}

export enum CodeNames {
  allAssets = 'all_assets',
  refProjectId = 'kontent_project_id',
  refPreviewKey = 'kontent_preview_key',
  refPreviewFlag = 'kontent_preview_flags',
  refTasksProjectId = 'kontent_tasks_project_id',
  refTasksPreviewKey = 'kontent_tasks_preview_key',
  refTasksPreviewFlag = 'kontent_tasks_preview_flags',
}

export enum AbsenceStatuses {
  pending = 'Pending',
  partial = 'Partial',
  approved = 'Approved',
  denied = 'Denied',
  accepted = 'Accepted',
  rejected = 'Rejected',
}

export enum CredentialPath {
  accessKeyId = 'config.credentials.accessKeyId',
  secretAccessKey = 'config.credentials.secretAccessKey',
  sessionToken = 'config.credentials.sessionToken',
}

export enum DataSources {
  availableCallCenterTimesBasedOn = '$availableCallCenterTimesBasedOn',
  callCenterClosures = '$callCenterClosures',
  formField = '$formField',
  formContext = '$formContext',
  toDate = '$toDate',
  weekends = '$weekends',
}

export enum EventTypes {
  navBarMount = 'navBarMount',
  navBarUnmount = 'navBarUnmount',
  navBarChange = 'navBarChange',
}

export enum FontNames {
  openSans = 'openSans',
  ubuntu = 'ubuntu',
}

export enum FontTypes {
  light = 'light',
  regular = 'regular',
  medium = 'medium',
  semibold = 'semibold',
  bold = 'bold',
}

export enum FormFieldTypes {
  checkbox = 'Checkbox',
  datepicker = 'DatePicker',
  dropdownlist = 'DropDownList',
  input = 'Input',
  leaveplangraph = 'LeavePlanGraph',
  maskedtextbox = 'MaskedTextBox',
  signer = 'Signer',
  switch = 'Switch',
  textarea = 'TextArea',
  timepicker = 'TimePicker',
  weeklyschedule = 'WeeklySchedule',
  claimsdropdownlist = 'ClaimsDropDownList',
  reducedschedule = 'ReducedSchedule',
  reducedschedulehours = 'ReducedScheduleHours',
  variableSchedule = 'VariableSchedule',
}

export enum FormFlags {
  allDay = 'all_day',
  blockProgress = 'blocks_progress',
  includeCallCenterClosureContext = 'include_call_center_closure_context',
  plainLabel = 'plain_label',
  required = 'required',
  card = 'card',
  showSteps = 'show_steps',
}

export enum FormStepFlags {
  hideWhenNoFields = 'hide_when_no_fields',
  hideStepper = 'hide_stepper',
}

export enum FormSectionTypes {
  FormButton = 'form_button',
  FormField = 'form_field',
  FormText = 'form_text',
}

export enum HubChannels {
  datePicker = 'date-picker',
  formContext = 'form-ontext',
  navBarButtonChannel = 'use-nav-bar-button',
  personDataContext = 'person-data-context',
  userInfo = 'user-info',
}

export enum HubEvents {
  append = 'append',
  init = 'init',
  refresh = 'refresh',
  refreshed = 'refreshed',
  set = 'set',
}

export enum KenticoDataKeys {
  assets = 'assets',
  callCenter = 'callCenter',
  featureFlags = 'featureFlags',
  config = 'config',
  localizedStrings = 'localizedStrings',
  dynamicContent = 'dynamicContent',
}

export enum DynamicContentMediums {
  full = 'dcContentFull',
  medium = 'dcContentMedium',
  short = 'dcContentShort',
}

export enum NoticeRequirementsKeys {
  asap = 'as_soon_as_possible',
  calendar_singular = 'calendar_day',
  calendar_plural = 'calendar_days',
  working_singular = 'working_day',
  working_plural = 'working_days',
}

export enum EREnvironmentCodes {
  dev = 'identifier_dev1',
  itest = 'identifier_itest1',
  uat = 'identifier_uat',
  prod = 'identifier',
}

export enum ERContentTypes {
  ERContent = 'employer_content',
  multipleChoice = 'multiple_choice',
  customTask = 'employer_custom_task',
  nextStep = 'employer_next_step',
}

export enum PregnancyTextChanges {
  pregnancyBondingLiteral = 'Pregnancy/Maternity',
  pregnancyBondingLiteralNew = 'Pregnancy',
}

export enum LeaveTypes {
  personalMedical = 'personalMedical',
  pregnancy = 'pregnancy',
}

export enum PaymentPrefsIds {
  Accounting = 66236000,
  DirectDeposit = 66236001,
  InternalAdjustment = 66236003,
  Check = 66236007,
  AdviceToPay = 66239010,
  Zelle = 66239997,
}

export enum RefreshStatus {
  failed = 'Failed',
  failedWithData = 'Failed with data',
  refreshed = 'refreshed',
  started = 'started',
  notRegisterable = 'Not registerable',
}
export enum ReminderTypes {
  SMSPref = 'SMSPref',
}

export enum ReminderIcons {
  ChatBubbles = 'ChatBubbles',
}

/**
 * keys for accessing items in the remote config
 */
export enum RemoteConfigKeys {
  awsSessionCheckIntervalMs = 'aws_session_check_interval_ms',
  awsSessionDurationHours = 'aws_session_duration_hours',
  uploadLimit = 'upload_file_size_limit',
  refreshCheckCount = 'refresh_check_count',
  refreshCheckIntervalMs = 'refresh_check_interval_ms',
  fullRefreshCheckCount = 'full_refresh_check_count',
  fullRefreshCheckIntervalMs = 'full_refresh_check_interval_ms',
  odyessiUrl = 'odyssei_preferences_url',
  showPaymentPrefs = 'show_payment_preferences_on_profile',
  hidePrefsForId = 'hide_payment_preferences_on_profile_for_employer_i',
  documentTitles = 'document_titles',
  hidePaymentInfoForIds = 'hide_payment_info_for_employer_ids',
  mandatoryExitReason = 'intake_exit_reason_mandatory',
  intakeExitReasons = 'intake_exit_reasons',
  exitPromptIntakes = 'exit_prompt_for_intakes',
  absenceApiInvokeUrl = 'absence_api_invoke_url',
  iServicesIDPURL = 'iservices_idp_url',
  employerVbMode = 'employer_vb_mode',
  employerVbList = 'employer_vb_list',
}

export type ToastTypes = {
  style: 'none' | 'success' | 'error';
  icon: boolean;
};

/**
 * Messages for field validations on the forms
 */
export enum ValidationErrors {
  hasContent = 'Please fill out this required field',
  signerHasContent = 'Please ensure that you have signed and filled out the required fields',
  weeklyScheduleHasContent = 'Please ensure all time values are valid',
  weeklyScheduleAllZeros = 'Please enter at least one time value for your schedule',
  noAlpha = 'No letters are allowed in this field',
  noNumeric = 'No number are allowed in this field',
  noSpecial = 'No special characters are allowed in this field',
  onlyAlpha = 'Only letters are allowed in this field',
  onlyNumberic = 'Only numbers are allowed in this field',
  matchesPattern = 'Please check this value again',
  dateGreaterThan = 'Please provide a date greater than the minimum',
  dateLesserThan = 'Please provide a date lesser than the maximum',
  dateGreaterThanOrEqual = 'Please provide a date greater than or equal to the minimum',
  dateLesserThanOrEqual = 'Please provide a date lesser than or equal to the maximum',
  isValidDate = 'Please enter a valid date',
  routingumberValid = 'Routing number not valid',
  slotsNotAvailable = 'No slot available for day',
  noSpecialChars = 'Special characters are not allowed. Please remove them to proceed.',
  durationGreaterThan = 'Please provide a duration greater than the minimum',
  durationLesserThan = 'Please provide a duration lesser than the maximum',
  durationGreaterThanOrEqual = 'Please provide a duration greater than or equal to the minimum',
  durationLesserThanOrEqual = 'Please provide a duration lesser than or equal to the maximum',
  isUniqueIntermittentAbsence = 'A matching absence has already been submitted. Modify the request to continue.',
  blockWhenVisible = 'If this field is visible, you cannot submit the form. Please remove the field to continue.',
  dateWorkingDay = "You weren't expected to work on these days. This includes weekends, holidays, shutdowns, or regular days off.",
}

export enum UploadStatus {
  allSuccessful = 'all_successful',
  someErrors = 'some_errors',
  allErrors = 'all_errors',
}

export enum AbsenceTypes {
  treatment = 'Treatment',
  episode = 'Episode',
  fineosType = 'Office Visit',
}

export enum RefreshDetailTypes {
  cases = 'refreshCases',
  caseDetails = 'refreshCaseDetail',
  documentDetails = 'refreshDocumentDetail',
  documents = 'refreshDocuments',
  leavePlans = 'refreshLeavePlans',
  person = 'refreshPerson',
  register = 'refreshRegister',
  tasks = 'refreshTasks',
}

export enum MilitaryReasonDescriptions {
  shortNoticeDeployment = 'This is a period of leave which lasts seven or less calendar days immediately preceding deployment.',
  militaryEvents = 'This describes any related official ceremony, program, or event sponsored by the military.',
  childcareActivities = 'This is on an urgent, immediate need basis only.',
  financialArrangements = "These are absences to make or update financial or legal arrangements to address the covered servicemember's absence " +
    '(e.g. preparing and executing financial and healthcare powers of attorney, transferring bank account signature authority).',
  counselling = 'This is for counseling for employee, military member, or the military member’s minor child or adult disabled child.',
  restLeave = 'This is a rest and recuperation period of up to 15 calendar days.',
  postDeploymentActivities = 'These are activities sponsored by the military following the termination of active duty status.',
  militaryDeath = 'These are activities sponsored by the military following the death of an active duty member.',
  parentalCare = 'This is on an urgent, immediate need basis only.',
  additionalActivities = 'This is for military related activities that you have agreed upon with your employer.',
}
